import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import styled from 'styled-components';

const LabelDiv = styled.div`
  width: 100px;
  font-size: 0.8em;
  margin-top: 6px;
`;


const TempClusterControlPanel = props => {
  const { bandWidth, setBandWidth } = props;
  const { thresholds, setThresholds } = props;
  const { scatOp, setScatOp } = props;
  const { cellSize, setCellSize } = props;
  const { interval, setInterval} = props;

  const buildSliders = () => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '-webkit-fill-available',
      }}
    >
      <div className="columns custom-rangeslider-horizontal">
        <LabelDiv>BandWidth</LabelDiv>
        <Slider
          min={1}
          max={100}
          value={bandWidth}
          orientation="horizontal"
          tooltip={false}
          onChange={v => setBandWidth(v)}
          labels={{}}
          handleLabel={bandWidth.toString()}
        />
      </div>
      <div className="columns custom-rangeslider-horizontal">
        <LabelDiv>Thresholds</LabelDiv>
        <Slider
          min={1}
          max={200}
          value={thresholds}
          orientation="horizontal"
          tooltip={false}
          onChange={v => setThresholds(v)}
          labels={{}}
          handleLabel={thresholds.toString()}
        />
      </div>
      <div className="columns custom-rangeslider-horizontal">
        <LabelDiv>Cell Size</LabelDiv>
        <Slider
          min={1}
          max={10}
          value={cellSize}
          orientation="horizontal"
          tooltip={false}
          onChange={v => setCellSize(v)}
          labels={{}}
          handleLabel={cellSize.toString()}
        />
      </div>
      <div className="columns custom-rangeslider-horizontal">
        <LabelDiv>Band Spacing</LabelDiv>
        <Slider
          min={1}
          max={10}
          value={interval}
          orientation="horizontal"
          tooltip={false}
          onChange={v => setInterval(v)}
          labels={{}}
          handleLabel={interval.toString()}
        />
      </div>
      <div className="columns custom-rangeslider-horizontal">
        <LabelDiv>Opacity</LabelDiv>
        <Slider
          min={1}
          max={10}
          value={scatOp}
          orientation="horizontal"
          tooltip={false}
          onChange={v => setScatOp(v)}
          labels={{}}
          handleLabel={scatOp.toString()}
        />
      </div>
    </div>
  );

  const handleRestoreDefaults = () => {
    setThresholds(30);
    setScatOp(8);
    setCellSize(4);
    setBandWidth(20);
    setInterval(5);
  }

  return (
    <div
      style={{ height: '300px' }}
      className="model-clust-perf-block"
      data-test="CusterModelPerfBlock"
    >
      <div className="mpcl-title" style={{ justifyContent: 'space-between' }}>
        <div>Control Panel (Dev Only)</div>
        <div>
          <button
            type="button"
            width="30px"
            height="20px"
            onClick={handleRestoreDefaults}
            style={{
              background: "#94A2B7", 
              color:'#FFFFFF',
              fontSize: "0.8em",
              borderRadius: "4px",
              padding: "0 3px 1px 3px"
             }}
          >
            restore
          </button>
        </div>
      </div>
      <div className="mpcl-body">{buildSliders()}</div>
    </div>
  );
};

TempClusterControlPanel.propTypes = {
  bandWidth: PropTypes.number,
  setBandWidth: PropTypes.func,
  thresholds: PropTypes.number,
  setThresholds: PropTypes.func,
  scatOp: PropTypes.number,
  setScatOp: PropTypes.func,
  cellSize: PropTypes.number,
  setCellSize: PropTypes.func,
  interval: PropTypes.number,
  setInterval: PropTypes.func,
};
export default TempClusterControlPanel;
